<template>
  <div style="margin-top:40px;">
    <el-form label-width="100px">
      <!-- 账户列表 下拉框-->
      <el-form-item label="账户列表" prop="accountCode">
        <el-select
          v-model="code"
          placeholder="请选择账户"
          style="width: 90%"
          filterable
        >
          <el-option
            v-for="item in accountList"
            :key="item.code"
            :label="item.bankName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <div class="btn_box">
      <el-button type="primary" :loading="loading" @click="handleConfirm"
        >确 定</el-button
      >
    </div>
  </div>
</template>

<script>
import { getAccountName, transferMoney } from "@/api/InternetBanking";

export default {
  name: "TransferDetail",
  props: {
    transformInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      accountList: [],
      code: ""
    };
  },
  watch: {
    transformInfo: {
      handler(val) {
        if (val) {
          this.fetchAccountList();
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 获取账户列表
    fetchAccountList() {
      getAccountName({ branchCode: this.transformInfo.branchCode })
        .then(response => {
          // 假设返回的数据结构是 response.data，并且包含 accountList
          // 如果 API 返回结构不同，需要根据实际情况调整
          // 这里假设返回的是一个列表
          this.accountList = response.data || [];
        })
        .catch(error => {
          console.error("获取账户列表失败", error);
        });
    },

    // 关闭弹窗
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
    // 确认转账
    handleConfirm() {
      this.loading = true;
      transferMoney({ code: this.code })
        .then(response => {
          this.$message.success("转账成功");
          this.handleClose();
          this.$emit("success");
        })
        .catch(error => {
          console.error("转账失败", error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style scoped>
.btn_box {
  width: 100%;
  text-align: center;
}
</style>
